import { Record } from 'immutable'

export interface ILeasePriceTerm {
  readonly comissionRate: number
  readonly fees: number
  readonly term: string
  readonly totalPerMonth: string
  readonly totalPerTerm: number
  readonly totalPerYear: number
}

const LeasePriceTermRecord = Record({
  comissionRate: 0,
  fees: 0,
  term: '',
  totalPerMonth: '',
  totalPerTerm: 0,
  totalPerYear: 0,
})

export class LeasePriceTerm extends LeasePriceTermRecord
  implements ILeasePriceTerm {
  public static fromJS(initialState?: Partial<ILeasePriceTerm>) {
    return new LeasePriceTerm(initialState)
  }

  public readonly comissionRate: number
  public readonly fees: number
  public readonly term: string
  public readonly totalPerMonth: string
  public readonly totalPerTerm: number
  public readonly totalPerYear: number

  constructor(props?: Partial<LeasePriceTerm>) {
    props ? super(props) : super()
  }
}
